/**
 * src/shell/gm-client/toast.ts — 壳层提示条（壳自己的反馈通道，不写引擎事件流）。
 *
 * 用途：壳侧操作反馈（录用/导出/导入/设置）与 GmError 玩家可读提示
 * （引擎错误 message 本就是游戏世界观文案，直接上浮）。
 */

export interface Toast {
  id: number
  text: string
  ts: number
}

type Listener = (toasts: Toast[]) => void
const listeners = new Set<Listener>()
let toasts: Toast[] = []
let nextId = 1

export function pushToast(text: string): void {
  toasts = [...toasts, { id: nextId++, text, ts: Date.now() }].slice(-5)
  for (const l of listeners) l(toasts)
}

export function dismissToast(id: number): void {
  toasts = toasts.filter((t) => t.id !== id)
  for (const l of listeners) l(toasts)
}

export function subscribeToasts(fn: Listener): () => void {
  listeners.add(fn)
  return () => listeners.delete(fn)
}

export function getToasts(): Toast[] {
  return toasts
}
